'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getVideoId = exports.getVideoUrl = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _bcGetSpm = require('@alife/bc-get-spm');

var _bcGetSpm2 = _interopRequireDefault(_bcGetSpm);

var _utils = require('./utils');

var _log = require('./log');

var _log2 = _interopRequireDefault(_log);

var _controls = require('./controls');

var _controls2 = _interopRequireDefault(_controls);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var VideoPlayer = function () {
  function VideoPlayer(config, options) {
    _classCallCheck(this, VideoPlayer);

    this.config = _extends({
      width: '100%',
      height: '100%'
    }, config);
    this.videoOptions = _extends({
      preload: 'metadata'
    }, options, {
      playsinline: true,
      'webkit-playsinline': true
    });
    var _config = this.config,
        container = _config.container,
        logOptions = _config.logOptions,
        videoId = _config.videoId,
        width = _config.width,
        controlOptions = _config.controlOptions,
        videoElement = _config.videoElement;


    if (videoElement) {
      videoElement.removeAttribute('class');
      videoElement.removeAttribute('style');
      this.elVideo = videoElement;
    } else {
      this.elVideo = document.createElement('video');
      this.setSource();
    }

    // 把video移动到统一的div内
    this.elRoot = document.createElement('div');
    var className = 'bc-video-player';
    var videoWidth = (0, _utils.getElWidth)(container, width);
    if (videoWidth < 300) {
      className += ' mini';
    }

    this.elRoot.className = className;
    this.elRoot.appendChild(this.elVideo);

    this.setAttrs();
    this.controls = new _controls2['default'](this.elVideo, controlOptions);
    container.appendChild(this.elRoot);

    var spmObj = (0, _bcGetSpm2['default'])(container);

    if (logOptions !== false) {
      this.log = new _log2['default'](this.elVideo, _extends({
        videoId: videoId,
        scene: spmObj && spmObj.c,
        hasVideoElement: !!videoElement
      }, logOptions));
    }

    // 对于外部传入的视频并且需要自动播放的，视频播放器自主出发play事件。
    var autoplay = this.videoOptions.autoplay;

    if (videoElement && autoplay) {
      this.elVideo.play();
    }
  }

  VideoPlayer.prototype.setSource = function setSource() {
    var _this = this;

    var _config2 = this.config,
        videoUrl = _config2.videoUrl,
        videoId = _config2.videoId,
        quality = _config2.quality;
    // 资源404错误无法被video元素捕获，只能使用source监听

    var elSource = document.createElement('source');
    elSource.src = videoUrl || (0, _utils.getVideoUrl)(videoId, quality);
    elSource.addEventListener('error', function (ev) {
      return _this.elVideo.dispatchEvent(new ev.constructor(ev.type, ev));
    });
    this.elVideo.appendChild(elSource);
  };

  VideoPlayer.prototype.setAttrs = function setAttrs() {
    var _this2 = this;

    var _config3 = this.config,
        width = _config3.width,
        height = _config3.height;

    Object.keys(this.videoOptions).forEach(function (attr) {
      _this2.elVideo[attr] = _this2.videoOptions[attr];
      // 类似autoplay属性，为false时不能加到dom的attribute中
      if (_this2.videoOptions[attr] === false) {
        return;
      }
      var attrVal = _this2.videoOptions[attr] === true ? '' : _this2.videoOptions[attr];
      _this2.elVideo.setAttribute(attr, attrVal);
    });
    this.elRoot.style.width = Number(width) ? Number(width) + 'px' : width;
    this.elRoot.style.height = Number(height) ? Number(height) + 'px' : height;

    // 隐藏原生controls
    this.elVideo.controls = false;

    // 静音需要特殊处理
    if (this.elVideo.muted) {
      (0, _utils.once)(this.elVideo, 'loadedmetadata', function () {
        return _this2.elVideo.muted = true;
      });
    }
  };

  VideoPlayer.prototype.destroy = function destroy() {
    this.log && this.log.destroy();
    this.controls.destroy();
  };

  return VideoPlayer;
}();

exports.getVideoUrl = _utils.getVideoUrl;
exports.getVideoId = _utils.getVideoId;
exports['default'] = VideoPlayer;